import { render, staticRenderFns } from "./ZhiqiTong1.vue?vue&type=template&id=c8af15f6&scoped=true"
import script from "./ZhiqiTong1.vue?vue&type=script&lang=js"
export * from "./ZhiqiTong1.vue?vue&type=script&lang=js"
import style0 from "./ZhiqiTong1.vue?vue&type=style&index=0&id=c8af15f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8af15f6",
  null
  
)

export default component.exports